import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=3faf6213&scoped=true"
import script from "./departmentList.vue?vue&type=script&lang=ts"
export * from "./departmentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf6213",
  null
  
)

export default component.exports